import $axios from '@/axios-instance.js'

class RegistriesPhotoboothsServiceClass {
  baseUrl = '/api/v1/admin/registries'
  child = 'photo-booths'

  // Create
  store(event_config, params) {
    return $axios.post(`${this.baseUrl}/${event_config}/${this.child}`, params)
  }

  // Read all - findAll
  index(event_config, params) {
    return $axios.get(`${this.baseUrl}/${event_config}/${this.child}`, params)
  }

  // Read one - show
  show(id, params) {
    return $axios.get(this.baseUrl + `/${id}`, params)
  }

  // Update
  update(id, params) {
    return $axios.put(this.baseUrl + `/${id}`, params)
  }

  // Delete - delete
  destroy(id, params) {
    return $axios.delete(this.baseUrl + `/${id}`, params)
  }
}
export const RegistriesPhotoboothsService =
  new RegistriesPhotoboothsServiceClass()
